import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { range } from '../../helpers/range';
@Component({
  selector: 'app-pagination-v2',
  templateUrl: './pagination-v2.component.html',
  styleUrls: ['./pagination-v2.component.scss']
})
export class PaginationV2Component {

  @Input() page: number = 1;
  @Input() count: number;
  @Input() size: number = 12;
  @Input() resource: string;
  @Output() pageChanged: EventEmitter<any> = new EventEmitter();


  pages: number[] = [];
  start: number;
  finish: number;
  loading: boolean;

  // tslint:disable-next-line:variable-name
  showing_all: boolean;

  constructor() { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['count']) {
      this.paginate()
    }
  }



  goto(page: number) {
    this.page = page;
    this.pageChanged.emit({
      page: this.page,
      size: this.size,
    })
  }

  prev() {
    if (this.page - 1 > 0) {
      this.page--;
    }
    this.pageChanged.emit({
      page: this.page,
      size: this.size,
    })
  }

  next() {
    if (this.page + 1 <= this.pages.length) {
      this.page++;
    }
    this.pageChanged.emit({
      page: this.page,
      size: this.size,
    })
  }

  private paginate() {
    if (this.page === 1 && this.count < this.size) {
      this.showing_all = true;
      return;
    } else {
      this.showing_all = false;
    }
    this.start = (this.page - 1) * this.size + 1;
    const finish = this.page * this.size;
    this.finish = finish > this.count ? this.count : finish;
    const pages = Math.ceil(this.count / this.size);
    if (pages > 1) {
      this.pages = range(1, pages); // +1
    }

  }

  getPageList(totalPages: number, page: number, maxLength: number) {

    if (maxLength < 5) return;

    const sideWidth = maxLength < 9 ? 1 : 2;
    const leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
    const rightWidth = (maxLength - sideWidth * 2 - 2) >> 1;
    if (totalPages <= maxLength) {
      // no breaks in list
      return range(1, totalPages);
    }
    if (page <= maxLength - sideWidth - 1 - rightWidth) {
      // no break on left of page
      return range(1, maxLength - sideWidth - 1)
        .concat(0, range(totalPages - sideWidth + 1, totalPages));
    }
    if (page >= totalPages - sideWidth - 1 - rightWidth) {
      // no break on right of page
      return range(1, sideWidth)
        .concat(0, range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages));
    }
    // Breaks on both sides
    return range(1, sideWidth)
      .concat(0, range(page - leftWidth, page + rightWidth),
        0, range(totalPages - sideWidth + 1, totalPages));
  }

}
